import { Base } from 'layouts'
import { ManageIndustryGroup as ToManage } from 'components'

import * as S from './styled'

export function ManageIndustryGroup() {
  return (
    <Base>
      <S.GridContainer container>
        <ToManage />
      </S.GridContainer>
    </Base>
  )
}
